import {Component} from '@angular/core';
import {
    FormSectionComponent
} from "../../common/forms/form-section/form-section.component";
import {
    AppAlertService,
    ParametersService, SettingsAccountService, SettingsModuleInfoService,
    SettingsSaveService,
    SettingsService,
    SubtitlesService
} from "../../core";
import {
    FormCardButtonComponent
} from "../../common/forms/form-card-button/form-card-button.component";
import {ModuleData} from "../../models";
import {AppDialogComponent} from "../../common/app-dialog/app-dialog.component";
import {PinFormComponent} from "./pin-form/pin-form.component";

@Component({
    selector: 'settings-module-options',
    standalone: true,
    imports: [
        FormSectionComponent,
        FormCardButtonComponent,
        AppDialogComponent,
        PinFormComponent
    ],
    templateUrl: './settings-module-options.component.html',
    styleUrl: './settings-module-options.component.scss'
})
export class SettingsModuleOptionsComponent {
    constructor(
        private parameters: ParametersService,
        public appAlert: AppAlertService,
        public settingsAccount: SettingsAccountService,
        public settingsModuleInfo: SettingsModuleInfoService,
        public settings: SettingsService,
        public settingsSave: SettingsSaveService,
        private subtitles: SubtitlesService,
    ) {
    }


    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    sendPw(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
        } else {
            this.appAlert.openConfirmDialog({
                title: this.subtitle(734),
                message: this.subtitle(1326) + '. ' + this.subtitle(1934),
                okButtonText: this.subtitle(1952),
                cancelButtonText: this.subtitle(71),
                okFunction: this.settingsModuleInfo.sendPw.bind(this.settingsModuleInfo)
            })
        }
    }

    deleteModule(module: ModuleData): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
        } else {
            this.settingsModuleInfo.deleteModuleUdid = module.udid;
            this.appAlert.openConfirmDialog({
                title: this.subtitle(2877),
                message: `${this.subtitles.setSubtitle(2878)}: ${module.name}?`,
                okButtonText: this.subtitle(2880),
                cancelButtonText: this.subtitle(71),
                okFunction:  this.settingsModuleInfo.deleteModule.bind(this.settingsModuleInfo),
            })
        }
    }

    closeDialog(): void {
        this.settingsSave.showInput = false;
    }
}
